import React from "react";
import { Icon } from "./primitives.jsx";

/* Footer ink band. `go(pageId)` navigates real URLs (see main.jsx). */
export function Footer({ go, footer }) {
  const linkTargets = {
    Articles: "articles",
    บทความ: "articles",
    Careers: "careers",
    ร่วมงาน: "careers",
    "Contact us": "contact",
    ติดต่อเรา: "contact"
  };
  return (
    <footer style={{ background: "var(--brand-ink)", color: "var(--neutral-300)" }}>
      <div style={{ width: "100%", maxWidth: "var(--container-max)", margin: "0 auto", padding: "var(--space-10) var(--gutter) var(--space-7)" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1.6fr repeat(3, 1fr)", gap: "var(--space-7)", alignItems: "start" }} className="rw-foot-grid">
          <div>
            <img src="/assets/logo-rework-white.png" height="30" alt="Rework" style={{ height: 30, width: "auto", display: "block" }} />
            <p style={{ marginTop: "var(--space-4)", fontSize: "var(--text-sm)", lineHeight: 1.65, color: "var(--neutral-400)", maxWidth: 320 }}>{footer.blurb}</p>
            <div style={{ marginTop: "var(--space-4)", fontFamily: "var(--font-mono)", fontSize: 13, fontWeight: 600, letterSpacing: "0.02em", color: "var(--neutral-0)" }}>{footer.tagline}</div>
          </div>
          {footer.cols.map((col) => (
            <div key={col.title}>
              <div style={{ fontSize: "var(--text-xs)", fontWeight: 700, letterSpacing: "var(--tracking-widest)", textTransform: "uppercase", color: "var(--neutral-500)", marginBottom: "var(--space-4)" }}>{col.title}</div>
              <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column", gap: 10 }}>
                {col.links.map((l) => {
                  const tgt = linkTargets[l];
                  return (
                    <li key={l}>
                      <button
                        onClick={() => tgt && go(tgt)}
                        style={{ background: "none", border: "none", padding: 0, cursor: tgt ? "pointer" : "default", textAlign: "left", fontFamily: "var(--font-sans)", fontSize: "var(--text-sm)", color: "var(--neutral-300)", transition: "color var(--duration-base) var(--ease-out)" }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = "var(--neutral-0)")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "var(--neutral-300)")}
                      >
                        {l}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>
        <div style={{ marginTop: "var(--space-8)", paddingTop: "var(--space-5)", borderTop: "1px solid rgba(255,255,255,0.1)", display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: "var(--text-xs)", color: "var(--neutral-500)" }}>{footer.rights}{footer.partnerLine ? " · " + footer.partnerLine : ""}</span>
          <div style={{ display: "flex", gap: 16 }}>
            {["share-2", "at-sign", "globe"].map((s) => (
              <span
                key={s}
                style={{ display: "inline-flex", color: "var(--neutral-500)", cursor: "pointer", transition: "color var(--duration-base) var(--ease-out)" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "var(--neutral-0)")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "var(--neutral-500)")}
              >
                <Icon name={s} size={18} />
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
